var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-select',{ref:"select",attrs:{"search-data":_vm.search,"placeholder":"Não mostrar no DRE Gerencial"},on:{"input":(v) => _vm.$emit('input', v)},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }